export const computeCampaignImprovementPercent = (comments, campaignPeriod) => {
  if (!comments?.length || !campaignPeriod?.start || !campaignPeriod?.stop) {
    return null;
  }

  const start = new Date(campaignPeriod.start).getTime();
  const stop = new Date(campaignPeriod.stop).getTime();
  const midpoint = start + (stop - start) / 2;

  const getRemovalRate = (from, to) => {
    let total = 0;
    let removed = 0;

    comments.forEach((comment) => {
      const date = new Date(comment.notificationDate || comment.time).getTime();
      if (date < from || date > to) {
        return;
      }

      const number = Number(comment.number) || 0;
      if (!number) {
        return;
      }

      total += number;
      if (comment.objectRemoved === true) {
        removed += number;
      }
    });

    return total > 0 ? (removed / total) * 100 : null;
  };

  const firstRate = getRemovalRate(start, midpoint);
  const secondRate = getRemovalRate(midpoint, stop);

  if (firstRate == null || secondRate == null) {
    return null;
  }

  const improvement = Math.round(secondRate - firstRate);
  return improvement > 0 ? improvement : null;
};
